import React from 'react';
import { Helmet } from 'react-helmet';

import TrackingGenerator from './TrackingGenerator';
import { useOpenLinksInParentWindow } from './useOpenLinksInParentWindow';

type Props = {
  canonical?: string;
  description?: string;
  isNotIndexed?: boolean;
  isSingleExerciseMode: boolean;
  title: string;
};

const HeadManager: React.FC<Props> = ({
  canonical,
  description,
  isNotIndexed = false,
  isSingleExerciseMode,
  title,
}) => {
  useOpenLinksInParentWindow(isSingleExerciseMode);
  return (
    <>
      <Helmet>
        <title>{title}</title>
        {canonical && <link rel="canonical" href={canonical} />}
        {isNotIndexed && <meta name="robots" content="noindex" />}
        <meta httpEquiv="X-UA-Compatible" content="IE=edge,chrome=1" />
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1, maximum-scale=1"
        />
        <meta name="fragment" content="!" />
        <meta
          name="keywords"
          content="R, Python, Data analysis, interactive, learning"
        />
        <meta
          name="description"
          content={
            description ||
            'DataCamp is a free online interactive learning platform for data analytics. Think of it as Codecademy, but for data science.'
          }
        />

        <meta name="twitter:card" content="summary" />
        <meta name="twitter:site" content="@DataCamp" />
        <meta name="twitter:title" content={title} />
        <meta
          name="twitter:description"
          content={
            description ||
            'DataCamp is a free online interactive learning platform for data analytics. Think of it as Codecademy, but for data science.'
          }
        />

        <meta name="twitter:creator" content="@DataCamp" />
        <meta
          name="twitter:image:src"
          content="/public/assets/images/var/twitter_share.png"
        />
        <meta name="twitter:domain" content="www.datacamp.com" />
        <meta property="og:title" content={title} />
        <meta
          property="og:image"
          content="/public/assets/images/var/linkedin_share.png"
        />

        <meta
          name="google-signin-clientid"
          content="892114885437-01a7plbsu1b2vobuhvnckmmanhb58h3a.apps.googleusercontent.com"
        />
        <meta name="google-signin-scope" content="email profile" />
        <meta name="google-signin-cookiepolicy" content="single_host_origin" />
      </Helmet>
      <TrackingGenerator />
    </>
  );
};

export default HeadManager;
